import {axiosInstance} from '@/services/axiosInstance'


export const MccResource = {

getKeyValue: (parametros) => {
    return axiosInstance.get(
      'v1/mcc/keyvalue', 
      parametros
    )
  }

}

